/**
 * Determines whether a given pathname belongs to the "applicants flow" section of the website.
 *
 * @param {string | null} pathname - The full pathname to check.
 * @returns {boolean} - `true` if the pathname matches a valid "company job" route; otherwise, `false`.
 */
export const isApplicantsFlowRoute = (pathname: string | null): boolean => {
  // Return false if pathname is null or empty
  if (!pathname) {
    return false;
  }
  return /^\/(?:[a-z]{2}\/)?job\/[^/]+\/applicants\/(input-)?flow$/.test(pathname);
};
